import React, { useState } from "react";
import AccordionLists from "components/accordion";
import Footer from "components/global/footer";
import HeroBanner from "components/herobanner";
import Testimonials from "components/testimonials";
import { Helmet } from "react-helmet";
import { collection, addDoc } from "firebase/firestore";
import { db } from "firebase-config";

const feedData = [
  {
    id: 1,
    title: "Reduce Waste, Increase Value",
    description:
      "Turn surplus food into added income and reduce food waste effortlessly. Every meal saved is a step toward a more sustainable future.",
  },
  {
    id: 2,
    title: "Reach New Customers",
    description:
      "Gain exposure to a growing community of eco-conscious consumers who value sustainability and love discovering local restaurants, cafes, and stores.",
  },
  {
    id: 3,
    title: "Strengthen Your Brand",
    description:
      "Showcase your commitment to sustainability and social impact, building trust and loyalty with customers who prioritize responsible brands.",
  },
  {
    id: 3,
    title: "Simple Setup",
    description: `Our app makes it easy to list surplus items as "mystery bags" to surprise and delight your customers while minimizing waste. We handle the logistics—so you can focus on your business.`,
  },
  // Add more feed items as needed
];

const commitmentPartners = [
  {
    id: 0,
    title: "Support Every Step",
    description:
      "Our team is dedicated to helping you get the most out of your Surpeats experience. From onboarding to ongoing support, we’re here for you.",
    icon: (
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9974 0.666992C11.3603 0.666992 8.78245 1.44898 6.5898 2.91406C4.39714 4.37915 2.68818 6.46153 1.67901 8.89788C0.66984 11.3342 0.405795 14.0151 0.920265 16.6015C1.43473 19.1879 2.70461 21.5637 4.56931 23.4284C6.43401 25.2931 8.80978 26.563 11.3962 27.0775C13.9826 27.5919 16.6635 27.3279 19.0998 26.3187C21.5362 25.3096 23.6186 23.6006 25.0837 21.4079C26.5487 19.2153 27.3307 16.6374 27.3307 14.0003C27.3307 12.2494 26.9859 10.5156 26.3158 8.89788C25.6457 7.28021 24.6636 5.81035 23.4255 4.57224C22.1874 3.33412 20.7175 2.35199 19.0998 1.68193C17.4822 1.01187 15.7484 0.666992 13.9974 0.666992ZM19.7307 10.8137L13.6374 18.8137C13.5132 18.975 13.3537 19.1058 13.1711 19.1959C12.9885 19.286 12.7877 19.3332 12.5841 19.3337C12.3815 19.3348 12.1814 19.2897 11.9989 19.2019C11.8164 19.1141 11.6563 18.9859 11.5307 18.827L8.2774 14.6803C8.16972 14.542 8.09033 14.3838 8.04378 14.2148C7.99723 14.0458 7.98442 13.8693 8.00609 13.6953C8.02775 13.5214 8.08347 13.3534 8.17006 13.201C8.25665 13.0486 8.37241 12.9147 8.51073 12.807C8.7901 12.5895 9.14441 12.4919 9.49573 12.5357C9.66968 12.5573 9.83766 12.6131 9.99009 12.6997C10.1425 12.7862 10.2764 12.902 10.3841 13.0403L12.5574 15.8137L17.5974 9.14699C17.7042 9.00692 17.8376 8.88925 17.9898 8.80071C18.1421 8.71217 18.3104 8.65449 18.4849 8.63097C18.6595 8.60744 18.837 8.61853 19.0073 8.6636C19.1776 8.70868 19.3373 8.78685 19.4774 8.89366C19.6175 9.00047 19.7351 9.13382 19.8237 9.2861C19.9122 9.43839 19.9699 9.60662 19.9934 9.78119C20.017 9.95577 20.0059 10.1333 19.9608 10.3036C19.9157 10.4738 19.8375 10.6336 19.7307 10.7737V10.8137Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    id: 1,
    title: "Flexible & Scalable",
    description:
      "Whether you’re a single restaurant or a larger chain, Surpeats is tailored to suit your needs, offering flexibility in listings and pickups.",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.9123 8.6875C3.7123 5.975 5.97481 3.7125 8.68731 2.9125C10.7498 2.3125 12.1748 2.3625 13.1623 3.1C14.3498 3.9875 14.4873 5.5875 14.4873 6.725V9.8375C14.4873 12.9125 13.0873 14.475 10.3373 14.475H6.7498C5.6248 14.475 4.0123 14.3375 3.1248 13.15C2.3623 12.175 2.2998 10.75 2.9123 8.6875Z"
          fill="white"
        />
        <path
          d="M6.36275 16.7001C6.68775 16.3251 7.16275 16.1126 7.65025 16.1126H12.1252C14.3252 16.1126 16.1128 14.3251 16.1128 12.1251V7.65007C16.1128 7.16257 16.3252 6.68757 16.7002 6.36257C17.0627 6.03757 17.5627 5.88757 18.0377 5.95007C20.9752 6.32507 23.6752 7.93757 25.4377 10.3626C27.2127 12.8001 27.8627 15.7751 27.3002 18.7501C26.4877 23.0501 23.0502 26.4876 18.7377 27.3001C18.0502 27.4376 17.3627 27.5001 16.6752 27.5001C14.4127 27.5001 12.2252 26.8001 10.3627 25.4376C7.93775 23.6751 6.32525 20.9751 5.95025 18.0376C5.88775 17.5501 6.03775 17.0626 6.36275 16.7001Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    id: 2,
    title: "Growing Together",
    description:
      "As you help us fight food waste, we’ll work to bring more value to your business and drive more traffic to your doors.",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.2857 9.44444C19.2857 11.899 17.3669 13.8889 15 13.8889C12.6331 13.8889 10.7143 11.899 10.7143 9.44444C10.7143 6.98985 12.6331 5 15 5C17.3669 5 19.2857 6.98985 19.2857 9.44444Z"
          fill="white"
        />
        <path
          d="M8.39277 14.0972C8.39277 15.3245 7.43338 16.3194 6.24991 16.3194C5.06645 16.3194 4.10706 15.3245 4.10706 14.0972C4.10706 12.8699 5.06645 11.875 6.24991 11.875C7.43338 11.875 8.39277 12.8699 8.39277 14.0972Z"
          fill="white"
        />
        <path
          d="M25.8928 14.0972C25.8928 15.3245 24.9334 16.3194 23.7499 16.3194C22.5664 16.3194 21.6071 15.3245 21.6071 14.0972C21.6071 12.8699 22.5664 11.875 23.7499 11.875C24.9334 11.875 25.8928 12.8699 25.8928 14.0972Z"
          fill="white"
        />
        <path
          d="M21.9291 22.0236C22.306 22.9673 22.5 23.9787 22.5 25.0001H7.5C7.5 23.9787 7.694 22.9673 8.07091 22.0236C8.44782 21.08 9.00026 20.2226 9.6967 19.5003C10.3931 18.7781 11.2199 18.2052 12.1299 17.8143C13.0398 17.4235 14.0151 17.2223 15 17.2223C15.9849 17.2223 16.9602 17.4235 17.8701 17.8143C18.7801 18.2052 19.6069 18.7781 20.3033 19.5003C20.9997 20.2226 21.5522 21.08 21.9291 22.0236Z"
          fill="white"
        />
        <path
          d="M22.102 22.5C22.0495 22.3395 21.9918 22.1807 21.9291 22.0236C21.6492 21.3228 21.2724 20.6695 20.8117 20.0838C20.9008 19.9672 20.9965 19.8558 21.0984 19.7502C21.4466 19.3891 21.86 19.1026 22.3149 18.9072C22.7699 18.7117 23.2575 18.6111 23.75 18.6111C24.2425 18.6111 24.7301 18.7117 25.1851 18.9072C25.64 19.1026 26.0534 19.3891 26.4017 19.7502C26.7499 20.1113 27.0261 20.54 27.2146 21.0118C27.403 21.4836 27.5 21.9893 27.5 22.5H22.102Z"
          fill="white"
        />
        <path
          d="M7.89801 22.5C7.95054 22.3395 8.00819 22.1807 8.07091 22.0236C8.35085 21.3228 8.72763 20.6695 9.18832 20.0838C9.09919 19.9672 9.0035 19.8558 8.90165 19.7502C8.55343 19.3891 8.14003 19.1026 7.68506 18.9072C7.23009 18.7117 6.74246 18.6111 6.25 18.6111C5.75754 18.6111 5.26991 18.7117 4.81494 18.9072C4.35997 19.1026 3.94657 19.3891 3.59835 19.7502C3.25013 20.1113 2.97391 20.54 2.78545 21.0118C2.597 21.4836 2.5 21.9893 2.5 22.5H7.89801Z"
          fill="white"
        />
        <path
          d="M21.9291 22.0236C22.306 22.9673 22.5 23.9787 22.5 25.0001H7.5C7.5 23.9787 7.694 22.9673 8.07091 22.0236M21.9291 22.0236C21.5522 21.08 20.9997 20.2226 20.3033 19.5003C19.6069 18.7781 18.7801 18.2052 17.8701 17.8143C16.9602 17.4235 15.9849 17.2223 15 17.2223C14.0151 17.2223 13.0398 17.4235 12.1299 17.8143C11.2199 18.2052 10.3931 18.7781 9.6967 19.5003C9.00026 20.2226 8.44782 21.08 8.07091 22.0236M21.9291 22.0236C21.9918 22.1807 22.0495 22.3395 22.102 22.5H27.5C27.5 21.9893 27.403 21.4836 27.2146 21.0118C27.0261 20.54 26.7499 20.1113 26.4017 19.7502C26.0534 19.3891 25.64 19.1026 25.1851 18.9072C24.7301 18.7117 24.2425 18.6111 23.75 18.6111C23.2575 18.6111 22.7699 18.7117 22.3149 18.9072C21.86 19.1026 21.4466 19.3891 21.0984 19.7502C20.9965 19.8558 20.9008 19.9672 20.8117 20.0838C21.2724 20.6695 21.6492 21.3228 21.9291 22.0236ZM8.07091 22.0236C8.00819 22.1807 7.95054 22.3395 7.89801 22.5H2.5C2.5 21.9893 2.597 21.4836 2.78545 21.0118C2.97391 20.54 3.25013 20.1113 3.59835 19.7502C3.94657 19.3891 4.35997 19.1026 4.81494 18.9072C5.26991 18.7117 5.75754 18.6111 6.25 18.6111C6.74246 18.6111 7.23009 18.7117 7.68506 18.9072C8.14003 19.1026 8.55343 19.3891 8.90165 19.7502C9.0035 19.8558 9.09919 19.9672 9.18832 20.0838C8.72763 20.6695 8.35085 21.3228 8.07091 22.0236ZM19.2857 9.44444C19.2857 11.899 17.3669 13.8889 15 13.8889C12.6331 13.8889 10.7143 11.899 10.7143 9.44444C10.7143 6.98985 12.6331 5 15 5C17.3669 5 19.2857 6.98985 19.2857 9.44444ZM8.39277 14.0972C8.39277 15.3245 7.43338 16.3194 6.24991 16.3194C5.06645 16.3194 4.10706 15.3245 4.10706 14.0972C4.10706 12.8699 5.06645 11.875 6.24991 11.875C7.43338 11.875 8.39277 12.8699 8.39277 14.0972ZM25.8928 14.0972C25.8928 15.3245 24.9334 16.3194 23.7499 16.3194C22.5664 16.3194 21.6071 15.3245 21.6071 14.0972C21.6071 12.8699 22.5664 11.875 23.7499 11.875C24.9334 11.875 25.8928 12.8699 25.8928 14.0972Z"
          stroke="white"
          strokeWidth="1.875"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
];

const accordionData = [
  {
    title: "What is Surpeats, and how does it benefit my business?",
    content: `Surpeats is a platform that helps businesses like yours reduce food waste by selling surplus food to customers at a discount. This not only generates additional revenue but also attracts new customers, enhances your sustainability efforts, and helps your business gain visibility in the local community.`,
  },
  {
    title: " How do I become a Surpeats partner?",
    content: `To join as a partner, simply sign up on our website or through the app. After a quick
verification process, you’ll be able to start listing surplus items as mystery bags for customers to purchase.`,
  },
  {
    title: `What is a "mystery bag"?`,
    content: `A mystery bag is a selection of surplus food items you prepare based on what’s left at the end of the day. Customers won’t know exactly what they’ll receive, but they’ll enjoy a great
value mix of items that you choose to include.`,
  },
  {
    title: "How do I list surplus food on Surpeats?",
    content: `Through the partner portal, you can list surplus items as mystery bags. Specify the available quantity, set a price, and indicate the pickup time. This ensures transparency for customers and helps you manage inventory efficiently.`,
  },
  {
    title: "When do I receive payment for orders?",
    content: `Payments are processed regularly, and you’ll receive funds directly in your bank account
based on the terms outlined in your agreement. The payment process is seamless and designed to be hassle-free.`,
  },
  {
    title: "Is there flexibility in setting prices for mystery bags?",
    content: `Yes, you have full control over pricing. We recommend offering a discount of at least 50% to 70% to attract more customers. By doing so, you can maximize sales while clearing out
surplus stock effectively.`,
  },
  {
    title: "How does Surpeats help me reduce food waste?",
    content: `By offering surplus food at a discount, you can reach customers looking for good value and contribute to reducing food waste. Surpeats provides a platform that enables you to monetize what might otherwise be discarded, all while promoting sustainability.`,
  },
];

const testimonials = [
  {
    id: 0,
    // image: "images/testimonials-1.png",
    name: "— Rahul T., Restaurant Owner, Mumbai",
    // idName: "@fredericakoen",
    description: `Surpeats has been a game-changer for our restaurant! We’re able to sell surplus
food instead of wasting it, which adds to our revenue and improves our sustainability
efforts. The mystery bag idea is well-received by customers`,
  },
  {
    id: 1,
    // image: "images/testimonials-2.png",
    name: "— Meera P., Café Owner, Mumbai",
    // idName: "@johntompoe",
    description: `Partnering with Surpeats has been a fantastic experience. We’ve seen new
customers come through our doors who otherwise wouldn’t have discovered us.
However, there have been a few instances where customers showed up outside the
pickup window, leading to confusion. A reminder system or clearer communication
about pickup times would help.`,
  },
];

export default function Partner() {
  const [formData, setFormData] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    refferalCode: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "ContactFormPartner"), formData);
      alert("Form submitted successfully!");
      setFormData({
        userName: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        refferalCode: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting form: ", error);
      alert("There was an error submitting the form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>For partner</title>
      </Helmet>
      <HeroBanner
        showAppLogoInHeader={false}
        bgStyles={{ backgroundPosition: "center" }}
        sectionClassName="pt-36 pb-14 lg:py-52"
        heroBannerImgUrl="images/lake-shape-cutlery-plate-middle.png"
        title={`"Your Surplus Food, Our Shared Mission to Fight Food Waste."`}
        titleWrapperClassName="max-w-5xl mx-auto text-left lg:text-center"
      />
      <section className="pt-7 pb-9 lg:py-16">
        <div className="container">
          <div className="flex flex-col gap-10 lg:gap-20 lg:flex-row">
            <div className="w-full flex-1 max-w-[550px]">
              <h2 className="font-anton mb-9 text-4xl lg:mb-12 lg:text-5xl">
                Why Partner with Surpeats?
              </h2>
              <ul className="space-y-6">
                {feedData?.length > 0 &&
                  feedData.map((item, index) => {
                    return (
                      <li
                        key={`orderStep-${index}`}
                        className={`flex gap-4 m-0 items-center`}
                      >
                        <div className="relative flex">
                          <span
                            className={`absolute w-1 left-1/2 top-0 -translate-x-1/2 bg-[#EAEAEA] ${
                              index === feedData.length - 1
                                ? "bottom-0"
                                : "-bottom-[170px] lg:-bottom-[120px]"
                            }`}
                          />
                          <div className="flex items-center justify-center">
                            <span
                              className={`relative z-10 flex-1 block size-7 rounded-full bg-primary-200`}
                            />
                          </div>
                        </div>
                        <div className="flex w-full justify-between">
                          <div>
                            <div className="flex items-center gap-2">
                              <p className="flex-auto text-base font-semibold text-gray-900 mb-4">
                                {item.title}
                              </p>
                            </div>
                            <span className="block text-base text-gray-400">
                              {item?.description}
                            </span>
                          </div>
                        </div>
                      </li>
                    );
                  })}
              </ul>
            </div>
            <img
              src="images/take-away.jpg"
              alt="take away"
              width={524}
              height={730}
              className="object-cover w-[524px] h-[730px]"
            />
          </div>
        </div>
      </section>
      <section className="pt-9 lg:py-16">
        <div className="container">
          <div className="flex items-start flex-col-reverse lg:flex-row lg:gap-16">
            <div className="max-w-lg">
              <img
                alt="People hand shaking"
                src="images/people-shaking-hands-business.jpg"
                width={539}
                height={730}
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="max-w-[648px] w-full flex-1 ">
              <h3 className="text-3xl font-anton mb-10 lg:mb-16 lg:text-5xl">
                Our Commitment to Partners
              </h3>
              <ul className="space-y-14 lg:space-y-16">
                {commitmentPartners.map((item, index) => {
                  return (
                    <li
                      key={`commitmentPartner-${index}`}
                      className="flex items-start gap-6 lg:gap-8"
                    >
                      <span className="flex items-center justify-center p-5 bg-primary-200 rounded-lg">
                        {item.icon}
                      </span>

                      <div>
                        <h4 className="font-anton mb-2 text-lg lg:text-2xl">
                          {item.title}
                        </h4>
                        <p className="text-base text-[#94959B] font-normal lg:text-xl">
                          {item.description}
                        </p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="py-7 lg:py-16">
        <div className="container">
          <div className="flex items-center gap-5 flex-col lg:flex-row">
            <div className="max-w-[480px] w-full">
              <h4 className="font-anton text-3xl lg:text-5xl">
                Start Your Journey Today Joining Surpeats is easy and rewarding.
                Take the first step toward reducing waste, reaching new
                customers, and making a meaningful impact.
              </h4>
            </div>

            <div className="flex-1 w-full">
              <form className="space-y-8" onSubmit={handleSubmit}>
                <div className="space-y-6">
                  <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                    <div>
                      <label htmlFor="userName" className="input-label">
                        User Name
                      </label>
                      <input
                        type="text"
                        name="userName"
                        id="userName"
                        placeholder="Insert your username"
                        className="input"
                        value={formData.userName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="firstName" className="input-label">
                        First name
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        id="firstName"
                        placeholder="Insert your first name"
                        className="input"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="lastName" className="input-label">
                      Last name
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      id="lastName"
                      placeholder="Insert your last name"
                      className="input"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="input-label">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Insert your email"
                      className="input"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                    <div>
                      <label htmlFor="phoneNumber" className="input-label">
                        Phone number
                      </label>
                      <input
                        type="number"
                        name="phoneNumber"
                        id="phoneNumber"
                        placeholder="Insert your phone number"
                        className="input"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="refferalCode" className="input-label">
                        Referral Code
                      </label>
                      <input
                        type="text"
                        name="refferalCode"
                        id="refferalCode"
                        placeholder="Enter Referral code"
                        className="input"
                        value={formData.refferalCode}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="message" className="input-label">
                      Message the host (Optional)
                    </label>
                    <textarea
                      name="message"
                      id="message"
                      placeholder="Type here..."
                      className="input resize-none"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="flex justify-center">
                  <button
                    type="submit"
                    className="mx-auto px-14 py-4 bg-primary-200 rounded-lg text-base font-bold text-white"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Testimonials
        title="Internal Testimonials From Partners"
        description={`Internal testimonials are feedback from those involved in Surpeats' prelaunch, providing valuable insights into their experiences and viewpoints. This feedback can be both positive and constructive, highlighting the strengths of Surpeats as well as areas for improvement.`}
        testimonials={testimonials}
      />
      <AccordionLists accordionData={accordionData} />
      <Footer />
    </>
  );
}
